import React from 'react';
import classNames, { Argument } from 'classnames';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import Language from 'types/LanguageEnum';
import { getSelectedLanguage } from 'modules/translations/selectors';
import { createDictionary } from 'utils/objectUtils';

interface MandatorySymbolProps {
  className?: Argument;
  isFieldLabelSuffix?: boolean;
}

// Every span gets a font size from the base styles: the symbol inherits the size of the text it marks instead
const mandatorySymbolMarkStyleByLanguage = createDictionary<Language, string>(
  { [Language.JA_JP]: 'text-xxs! kiosk:text-base! leading-none!' },
  'text-[length:inherit]! leading-[inherit]!'
);

// The "*" glyph sits high: on field labels it is lowered onto the cap height, as in the mockups.
// A translated word (ja_jp "必須") already sits on the baseline.
const fieldLabelSuffixStyleByLanguage = createDictionary<Language, string>(
  { [Language.JA_JP]: '' },
  'relative top-[0.15em]'
);

const MandatorySymbol: React.FC<MandatorySymbolProps> = ({ className, isFieldLabelSuffix = false }) => {
  const language = useSelector(getSelectedLanguage);
  return (
    <span
      className={classNames(
        'text-danger-high whitespace-nowrap',
        mandatorySymbolMarkStyleByLanguage[language],
        isFieldLabelSuffix && fieldLabelSuffixStyleByLanguage[language],
        className
      )}
      aria-hidden="true"
    >
      <FormattedMessage id="mandatorySymbol" defaultMessage="*"/>
    </span>
  );
};

export default MandatorySymbol;
